import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { capitalize } from "../../../util/stringFormat";
import { getStatusClass, useStatusStyles } from "../../common/statusStyles";

const STATUSES = ["APPROVED", "PENDING", "TAKEDOWN", "REJECTED", "DELETED"];

const BulkStatusChangeButton = ({ disabled, onStatusSelect }) => {
  const classes = useStatusStyles();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleSelect = status => {
    setOpen(false);
    onStatusSelect(status);
  };

  return (
    <>
      <Button
        ref={anchorRef}
        onClick={() => setOpen(true)}
        disabled={disabled}
        style={{ backgroundColor: open && "rgba(0, 0, 0, 0.04)" }}
      >
        Change Status
      </Button>
      <Menu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {STATUSES.map(status => (
          <MenuItem
            key={status}
            onClick={() => handleSelect(status)}
            className={getStatusClass(status, classes)}
          >
            {capitalize(status.toLowerCase())}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default BulkStatusChangeButton;
